import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './lib/useAuth'
import Layout from './routes/Layout'
import Login from './routes/Login'
import Instances from './routes/Instances'
import InstanceDetail from './routes/InstanceDetail'
import Servers from './routes/Servers'
import Domains from './routes/Domains'
import Users from './routes/Users'
import Audit from './routes/Audit'
import Backups from './routes/Backups'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route index element={<Instances />} />
              <Route path="instancias/:id" element={<InstanceDetail />} />
              <Route path="servidores" element={<Servers />} />
              <Route path="dominios" element={<Domains />} />
              <Route path="backups" element={<Backups />} />
              <Route path="usuarios" element={<Users />} />
              <Route path="auditoria" element={<Audit />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
